import { ReactElement } from 'react';

import classNames from 'classnames';
import RcDrawer from 'rc-drawer';

import { DRAWER_CLASS } from '../../utils/constants';
import Button from '../Button/Button';
import CrossIcon from '../Icon/components/Cross';
import * as Styled from './Drawer.styles';
import { IDrawerProps } from './Drawer.types';

const DrawerHoc = ({ className, rootClassName, ...props }: IDrawerProps): ReactElement => (
  <RcDrawer rootClassName={classNames(rootClassName, className)} {...props} />
);

const Drawer = ({
  children,
  className = '',
  size = 'medium',
  header,
  footerAlignment = 'right',
  onClose,
  onCancel,
  cancelText = 'Cancel',
  onConfirm,
  confirmText = 'Confirm',
  sticky = false,
  paddings = 'tight',
  bodyPadding = true,
  borders = true,
  getContainer,
  maskMotion = {
    motionName: 'mask-motion',
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 300,
  },
  motion = (placement) => ({
    motionName: `panel-motion-${placement}`,
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 300,
  }),
  ...rest
}: IDrawerProps): ReactElement => (
  <Styled.Drawer
    as={DrawerHoc}
    className={className}
    prefixCls={DRAWER_CLASS}
    onClose={onClose}
    getContainer={getContainer}
    motion={motion}
    maskMotion={maskMotion}
    sticky={sticky}
    {...rest}
  >
    {header && (
      <Styled.DrawerHeader size={size} paddings={paddings} borders={borders}>
        {header}
        <Button icon={<CrossIcon />} iconOnly variant="transparent" size="small" onClick={onClose} />
      </Styled.DrawerHeader>
    )}

    <Styled.DrawerContent sticky={sticky} size={size} paddings={paddings} bodyPadding={bodyPadding}>
      {children}
    </Styled.DrawerContent>

    {(onCancel || onConfirm) && (
      <Styled.DrawerFooter size={size} footerAlignment={footerAlignment} paddings={paddings} borders={borders}>
        {onCancel && (
          <Button size={size} variant="outlined" onClick={onCancel}>
            {cancelText}
          </Button>
        )}
        {onConfirm && (
          <Button size={size} onClick={onConfirm}>
            {confirmText}
          </Button>
        )}
      </Styled.DrawerFooter>
    )}
  </Styled.Drawer>
);

export default Drawer;
